import React, { Suspense } from 'react'
import { useReapitConnect } from '@reapit/connect-session'
import { reapitConnectBrowserSession } from './reapit-connect-session'
import { Navigate, useLocation } from 'react-router'
import { Loader } from '@reapit/elements/deprecated/loader'
import { AccessModeProvider } from './access-mode-provider'

export const PrivateRouteWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { connectSession, connectInternalRedirect } = useReapitConnect(reapitConnectBrowserSession)
  const location = useLocation()

  if (!connectSession) {
    return <Loader fullPage />
  }

  if (connectInternalRedirect && location?.pathname !== connectInternalRedirect) {
    return <Navigate to={connectInternalRedirect} />
  }

  return (
    <AccessModeProvider>
      <Suspense fallback={<Loader fullPage />}>{children}</Suspense>
    </AccessModeProvider>
  )
}

export default PrivateRouteWrapper
